import {Component, OnInit} from '@angular/core';
import {AccountService} from '../../services/account.service';
import {AccountSharingService} from '../../services/account-sharing.service';
import {NotificationSettings, NotificationSettingsComTypeHeader, SaveNotificationSettings} from '../../models/notification-settings';

@Component({
    selector: 'app-notification-settings',
    templateUrl: './notification-settings.component.html',
    styleUrls: ['./notification-settings.component.scss'],
    standalone: false
})
export class NotificationSettingsComponent implements OnInit {

  notifications: NotificationSettings[] = [];
  unsavedNotifications: NotificationSettings[] = [];
  comTypes: NotificationSettingsComTypeHeader[] = [];

  constructor(
    private accountService: AccountService,
    private accountSharingService: AccountSharingService
  ) { }

  ngOnInit(): void {
    this.accountService.getNotificationSettings()
      .subscribe({
        next: n => {
          this.notifications = n;
          if (this.notifications?.length) {
            for (const notification of this.notifications) {
              if (notification?.comtype) {
                notification.comTypesParsed = JSON.parse(notification?.comtype);

                if (notification?.comTypesParsed?.length) {
                  for (const com of notification?.comTypesParsed) {
                    if (!this.comTypes?.some(c => c?.comms_type_id === com?.comms_type_id)) {
                      const comType = new NotificationSettingsComTypeHeader();
                      comType.comms_type_id = com?.comms_type_id;
                      comType.comms_type = com?.comms_type;
                      this.comTypes.push(comType);
                    }
                  }
                }
              }
            }
          }
          this.unsavedNotifications = JSON.parse(JSON.stringify(this.notifications));
          console.log('notifications', this.notifications);
        }
      });
  }

  onNotificationChecked(comType: NotificationSettingsComTypeHeader, notification: NotificationSettings, event: any): void {
    const checked = event?.target?.checked;
    const settings = new SaveNotificationSettings();
    for (const com of notification?.comTypesParsed) {
      if (com?.comms_type_id === comType?.comms_type_id) {
        settings.PersonId = notification?.person_id;
        settings.NotificationTypeId = com?.notification_type_id;
        settings.CommsTypeId = com?.comms_type_id;
        settings.isSelected = checked ? 1 : 0;
      }
    }

    if (settings?.NotificationTypeId && settings?.PersonId && settings?.CommsTypeId && settings?.isSelected >= 0) {
      this.accountSharingService.updateChangeNotification(JSON.stringify(settings));
    } else {
      this.accountSharingService.updateChangeNotification('');
    }
  }

  checkNotificationChecked(comType: NotificationSettingsComTypeHeader, notification: NotificationSettings): boolean {
    if (comType && notification && notification?.comTypesParsed?.length) {
      const notificationCom = notification?.comTypesParsed?.find(n => n?.comms_type_id === comType?.comms_type_id);
      return notificationCom?.select === 1;
    } else {
      return false;
    }
  }

}
